import { Component, computed, input, InputSignal, Signal } from '@angular/core';

import { HowItWorksBlockSection } from '@core/cms/landing.cms';
import { CmsMedia } from '@shared/models/cms.model';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { AddStrapiDomainNamePipe } from '@shared/pipes/add-strapi-domain-name/add-strapi-domain-name.pipe';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/**
 * Renders a `ComponentSectionHowItWorksBlock`: a centered title over a row of numbered steps (each an
 * optional image + rich content), an optional footer, and an optional background image.
 *
 * This project has no auth, so the CMS login/sign-up/search call-to-action (`notRegisteredButtonType`
 * and the `*ButtonLabel` fields) is intentionally not rendered — only the informational content is.
 */
@Component({
    selector: 'cms-how-it-works-block',
    imports: [CmsImage, AddStrapiDomainNamePipe, TrustHtmlPipe],
    templateUrl: './how-it-works-block.html',
    styleUrl: './how-it-works-block.scss',
})
export class CmsHowItWorksBlock {
    public readonly section: InputSignal<HowItWorksBlockSection> =
        input.required<HowItWorksBlockSection>();

    /** First background image — the CMS field is a media list; `null` when none is set. */
    protected readonly backgroundImage: Signal<CmsMedia | null> = computed(
        (): CmsMedia | null => this.section().howItWorksBackgroundImage?.[0] ?? null,
    );
}
